import React, { FC, ReactNode } from 'react';
import { View, ViewStyle } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { Theme } from '@constants';

import { styles } from './styles';

export const TWCTileContent: FC<TWCTileContentProps> = ({
  backgroundDefault,
  gradientType = 'tile',
  reverseGradient = false,
  height = 0,
  width = 0,
  children,
  useLinearGradient = true,
  useFocusBorder = true,
  styleFocused,
  focused = false,
}) => {
  const innerTWCTileContent = (
    <View
      style={[
        useFocusBorder && styles.tile,
        // eslint-disable-next-line react-native/no-inline-styles
        {
          height: height ? Theme.px(height) : 'auto',
          width: width ? Theme.px(width) : 'auto',
        },
        !useFocusBorder && {
          borderRadius: Theme.tileBorderRadius,
        },
        !useLinearGradient && backgroundDefault,
        focused && styleFocused,
      ]}
    >
      {children}
    </View>
  );

  return useLinearGradient ? (
    <LinearGradient
      colors={
        reverseGradient
          ? [Theme.gradients[gradientType].end, Theme.gradients[gradientType].start]
          : [Theme.gradients[gradientType].start, Theme.gradients[gradientType].end]
      }
      style={{ borderRadius: Theme.tileBorderRadius }}
    >
      {innerTWCTileContent}
    </LinearGradient>
  ) : (
    <View style={{ borderRadius: Theme.tileBorderRadius }}>{innerTWCTileContent}</View>
  );
};

export type TWCTileContentProps = {
  children?: ReactNode;
  reverseGradient?: boolean;
  height?: number;
  width?: number;
  backgroundDefault?: ViewStyle;
  gradientType?: GradientType;
  useLinearGradient?: boolean;
  useFocusBorder?: boolean;
  styleFocused?: ViewStyle;
  focused?: boolean;
};

type GradientType =
  | 'alertModal'
  | 'vodBackground'
  | 'alertTile'
  | 'anfTile'
  | 'background'
  | 'loading'
  | 'onboarding'
  | 'tile'
  | 'deselectedTile'
  | 'drawerModalBackground'
  | 'settingsContent';
